'use client'

import React from 'react'

import { Global } from '@emotion/react'

export const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'Soehne';
        src: url(/fonts/Sohne/soehne-buch.woff2) format('woff2');
        font-weight: 400;
        font-style: normal;
      }
      @font-face {
        font-family: 'Soehne';
        src: url(/fonts/Sohne/soehne-buch-kursiv.woff2) format('woff2');
        font-weight: 400;
        font-style: italic;
      }
      @font-face {
        font-family: 'Soehne';
        src: url(/fonts/Sohne/soehne-kraftig.woff2) format('woff2');
        font-weight: 700;
        font-style: normal;
      }
      @font-face {
        font-family: 'Soehne';
        src: url(/fonts/Sohne/soehne-kraftig-kursiv.woff2) format('woff2');
        font-weight: 700;
        font-style: italic;
      }
      @font-face {
        font-family: 'Soehne Breit';
        src: url(/fonts/Sohne/soehne-breit-kraftig.woff2) format('woff2');
        font-weight: 500;
        font-style: normal;
      }
      @font-face {
        font-family: 'Soehne Kraftig';
        src: url(/fonts/Sohne/soehne-kraftig.woff2) format('woff2');
        font-weight: 500;
        font-style: normal;
      }
      @font-face {
        font-family: 'Soehne Mono';
        src: url(/fonts/Sohne/soehne-mono-buch.woff2) format('woff2');
        font-weight: 400;
        font-style: normal;
      }
    `}
  />
)
